
export default {
  name: 'CallToAction',
  props: {
    action: {
      type: String,
      default: undefined
    },
    buttonText: {
      type: String,
      required: true
    },
    goToLandingPage: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  computed: {
    hasGoToLandingPage () {
      return this.goToLandingPage?.data
    },
    landingPageUrl () {
      return this.goToLandingPage?.data?.attributes?.url
    }
  }
}
